// extracted by mini-css-extract-plugin
export default {"todoListContainer":"TodoList_todoListContainer__UhdBS"};